import React, { useState, useEffect } from "react";
import apiClient from "../../utils/apiClient";
import { format } from "date-fns";

const MessageLogsTab = ({ searchTerm = "" }) => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let interval;
    const fetchLogs = async () => {
      try {
        const response = await apiClient.get("messages/status");
        if (response.data && response.data.status === "success") {
          setLogs(response.data.data);
        } else {
          setError("Failed to fetch logs.");
        }
      } catch (err) {
        setError(err.message || "Something went wrong.");
      } finally {
        setLoading(false);
      }
    };
    
    fetchLogs();
    interval = setInterval(fetchLogs, 5000); // Poll every 5s
    
    return () => clearInterval(interval);
  }, []);

  const filteredLogs = logs.filter((log) => {
    if (!searchTerm) return true;
    const s = searchTerm.toLowerCase();
    const nameMatch = log.client_name?.toString().toLowerCase().includes(s);
    const phoneMatch = log.client_phone?.toString().toLowerCase().includes(s);
    const waMatch = log.whatsapp_status?.toString().toLowerCase().includes(s);
    const emailMatch = log.email_status?.toString().toLowerCase().includes(s);
    return nameMatch || phoneMatch || waMatch || emailMatch;
  });

  return (
    <div className="bg-[#121316] rounded-md shadow-md p-6 h-full flex flex-col">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-xl font-bold text-white">Delivery Logs</h2>
        <span className="text-sm text-gray-400">Updates automatically</span>
      </div>

      {loading && logs.length === 0 ? (
        <div className="flex-1 flex justify-center items-center text-white">Loading...</div>
      ) : error ? (
        <div className="flex-1 flex justify-center items-center text-red-500">{error}</div>
      ) : (
        <div className="flex-1 overflow-auto rounded-md border border-[#2b2d36]">
          <table className="min-w-full text-sm text-left text-gray-300">
            <thead className="text-xs text-gray-400 uppercase bg-[#1e2025] sticky top-0">
              <tr>
                <th className="px-6 py-3 border-b border-[#2b2d36]">Time</th>
                <th className="px-6 py-3 border-b border-[#2b2d36]">Client Name</th>
                <th className="px-6 py-3 border-b border-[#2b2d36]">Phone</th>
                <th className="px-6 py-3 border-b border-[#2b2d36]">WhatsApp</th>
                <th className="px-6 py-3 border-b border-[#2b2d36]">Email</th>
              </tr>
            </thead>
            <tbody>
              {filteredLogs.map((log, idx) => (
                <tr key={idx} className="bg-[#121316] border-b border-[#2b2d36] hover:bg-[#1a1b1f] transition-colors">
                  <td className="px-6 py-4 whitespace-nowrap">
                    {log.updated_at ? format(new Date(log.updated_at), "MMM d, HH:mm:ss") : "-"}
                  </td>
                  <td className="px-6 py-4 font-medium text-white">{log.client_name || "-"}</td>
                  <td className="px-6 py-4">{log.client_phone || "-"}</td>
                  <td className="px-6 py-4">
                    <span className={`px-2 py-1 rounded text-xs font-semibold ${
                      log.whatsapp_status?.toLowerCase() === 'delivered' || log.whatsapp_status?.toLowerCase() === 'read' ? 'bg-green-500/10 text-green-400' :
                      log.whatsapp_status?.toLowerCase() === 'failed' || log.whatsapp_status?.toLowerCase() === 'bounced' ? 'bg-red-500/10 text-red-400' :
                      log.whatsapp_status?.toLowerCase() === 'sent' ? 'bg-yellow-500/10 text-yellow-400' :
                      log.whatsapp_status === '-' ? 'text-gray-500' : 'bg-gray-500/10 text-gray-400'
                    }`}>
                      {log.whatsapp_status}
                    </span>
                  </td>
                  <td className="px-6 py-4">
                    <span className={`px-2 py-1 rounded text-xs font-semibold ${
                      log.email_status?.toLowerCase() === 'delivered' || log.email_status?.toLowerCase() === 'read' ? 'bg-green-500/10 text-green-400' :
                      log.email_status?.toLowerCase() === 'failed' || log.email_status?.toLowerCase() === 'bounced' ? 'bg-red-500/10 text-red-400' :
                      log.email_status?.toLowerCase() === 'sent' ? 'bg-yellow-500/10 text-yellow-400' :
                      log.email_status === '-' ? 'text-gray-500' : 'bg-gray-500/10 text-gray-400'
                    }`}>
                      {log.email_status}
                    </span>
                  </td>
                </tr>
              ))}
              {filteredLogs.length === 0 && (
                <tr>
                  <td colSpan="5" className="px-6 py-8 text-center text-gray-500">
                    No logs found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default MessageLogsTab;
